import { createSelector } from "reselect";
import Cookies from "js-cookie";

const getAuth = state => state.auth;

export const getOperatorEmail = createSelector([getAuth], (auth = {}) => {
	return auth.operatorEmail;
});

export const getOperatorAuthToken = createSelector([getAuth], (auth = {}) => {
	return auth.operatorAuthToken;
});

export const isOperatorMode = createSelector(
	[getOperatorEmail, getOperatorAuthToken],
	(operatorEmail, operatorAuthToken) => {
		return Boolean(operatorEmail) && Boolean(operatorAuthToken);
	}
);

export const getUUID = createSelector([getAuth], (auth = {}) => {
	return auth.uuid;
});

export const getSessionBiid = createSelector([getAuth], (auth = {}) => {
	return auth.sessionBiid;
});

/**
 * Vérifie si l'utilisateur est authentifié ou pas
 * Préférer cette méthode plutot que getCredentials si on a besoin de savoir cote serveur si le user est authentifié ou non
 * @returns {boolean} true si authentifié
 */
export const isAuthenticated = state => {
	return Boolean(
		Cookies.get("auth", { path: `/${state?.shop}` }) === "auth" &&
		Cookies.get("authToken", { path: `/${state?.shop}` })
	);
};

export const isIdentified = createSelector(
	[getAuth, isAuthenticated],
	(auth = {}, isAuthenticated = false) => {
		return !isAuthenticated && Boolean(auth?.uuid);
	}
);
